var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Eswatini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3949ab",
    d: "M24,4c-5.592,0-10.642,2.301-14.271,6h28.543C34.642,6.301,29.592,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3949ab",
    d: "M38.271,38H9.729c3.629,3.699,8.679,6,14.271,6S34.642,41.699,38.271,38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M39.973,36H8.027c0.528,0.701,1.088,1.375,1.701,2h28.543C38.885,37.375,39.445,36.701,39.973,36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M38.271,10H9.729c-0.613,0.625-1.174,1.299-1.701,2h31.946C39.445,11.299,38.885,10.625,38.271,10z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M44,24c0-4.509-1.51-8.655-4.027-12H8.027C5.51,15.345,4,19.491,4,24c0,4.509,1.51,8.655,4.027,12 h31.946C42.49,32.655,44,28.509,44,24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.168,18.5l-2.832,1l2.832,1l2.832-1L38.168,18.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M11.227,19h25.547C36.898,19,37,19.223,37,19.5S36.898,20,36.773,20H11.227 C11.102,20,11,19.777,11,19.5S11.102,19,11.227,19z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.168,21.5l-2.832,1l2.832,1l2.832-1L37.168,21.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M9.227,22h26.547C35.898,22,36,22.223,36,22.5S35.898,23,35.773,23H9.227C9.102,23,9,22.777,9,22.5 S9.102,22,9.227,22z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M6.312,25h35.375C41.859,25,42,25.223,42,25.5S41.859,26,41.687,26H6.312C6.141,26,6,25.777,6,25.5 S6.141,25,6.312,25z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35,24c-2.199,2.332-5.133,7-11,7c-5.133,0-8.801-4.668-11-7c2.199-2.336,5.867-7,11-7 C29.867,17,32.801,21.668,35,24z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M26.074,30.742c-0.215-1.188-2.91-1.523-2.863-1.934c0.082-0.461,2.012-0.398,2.035-0.797 c0.023-0.402-1.785-0.656-1.73-1.105c0.043-0.477,0.934-0.523,0.965-1.266c0.02-1.289,1.113-1.25,1.109-1.668 c-0.008-0.402-0.344-0.008-0.742-0.566c-0.395-0.539,0.055-2.168-0.352-2.184c-0.586-0.023-0.191-0.711-0.883-0.762 c-0.66-0.047-0.141-0.328-0.762-1.027h0.004c-0.773-0.922,0.68-2.309,0.793-2.414C18.699,17.23,15.148,21.723,13,24 c2.203,2.332,5.867,7,11,7c0.742,0,1.437-0.074,2.09-0.211C26.082,30.773,26.078,30.762,26.074,30.742z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M26,21h1v2h-1V21z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M28,21h1v2h-1V21z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M30,21h1v2h-1V21z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M26,25h1v2h-1V25z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M28,25h1v2h-1V25z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M30,25h1v2h-1V25z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17,21h1v2h-1V21z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19,21h1v2h-1V21z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21,21h1v2h-1V21z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17,25h1v2h-1V25z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19,25h1v2h-1V25z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21,25h1v2h-1V25z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#3949ab",
    d: "M39.801,25c-0.332,0.531,0.258-0.176,1.699,0.715c0.266,0.164,0.5,0.602,0.5,0.902 c-0.066-0.043-0.117-0.133-0.191-0.195c-0.105,0.098,0.098,0.539,0.129,0.746c-0.227-0.117-0.203-0.172-0.281-0.313 c0.016,0.172-0.039,0.645,0.055,0.828c-0.18-0.047-0.168-0.18-0.262-0.203c0.063,0.203-0.055,0.43-0.023,0.66 c-0.105-0.094-0.215-0.168-0.262-0.203c-0.008,0.109-0.199,0.398-0.203,0.504c-0.09-0.051-0.113-0.125-0.129-0.176 c-0.109,0.125-0.5,0.59-0.523,0.734c-0.301-0.242-1.066-0.836-1.168-1.148c-0.086,0.176-0.215,0.238-0.469,0.367 c-0.102-0.496-0.473-1.055-0.273-1.484c-0.141,0.078-0.258,0.156-0.402,0.25C38.133,26.266,38.816,25.418,39.801,25z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#3949ab",
    d: "M7.363,25.426c-0.02-0.168,0.02-0.188-0.09-0.316c0.156,0.066,0.164,0.23,0.359,0.113 c0.07-0.035,0.102-0.035,0.016-0.223c0.199,0.008,0.863,0.223,0.969,0.227c0.277,0.012,0.785-0.273,1.141,0.078 c0.336,0.324,0.223,0.66,0.223,1.105c-0.133-0.063-0.07-0.094-0.215-0.25c0.109,0.391-0.004,1.094-0.004,1.508 c-0.059-0.102-0.047-0.059-0.102-0.16c-0.145,0.379-0.316,0.457-0.316,0.902c-0.055-0.176-0.004-0.141-0.063-0.23 C9.141,28.465,8.199,28.711,8.562,29c-0.324-0.18-0.469-0.16-0.617-0.324c-0.063,0.039-0.117,0.113-0.176,0.211 c-0.574-0.25-0.367-0.785-0.82-1.145c-0.078,0.148-0.043,0.129-0.125,0.371c-0.094-0.34-0.117-0.555-0.219-0.805 c-0.09,0.137-0.082,0.086-0.242,0.293c-0.066-0.414-0.176-0.512-0.133-0.785C6.059,26.93,6.172,26.883,6,27.023 C6.16,25.961,6.859,25.172,7.363,25.426z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3949ab",
    d: "M20.609,18c-0.301,0.547,0.523-0.184,1.813,0.734C22.656,18.902,23,19.574,23,19.887 c-0.273-0.055-0.762-0.313-0.762-0.313s0.57,0.539,0.57,1.164c-0.199-0.121-0.301-0.102-0.367-0.25c0,0.203,0.18,0.332,0.18,0.645 c-0.145-0.113-0.27-0.184-0.391-0.25c0.188,0.313-0.348,0.918-0.078,1.117c-0.469-0.063-0.949-0.348-1.141-0.66 c-0.102,0.066-0.113,0.168-0.117,0.273c0.016,0.012-0.711-0.512-0.645-0.715c-0.098,0.133-0.113,0.203-0.137,0.348 c-0.266-0.25-0.512-0.5-0.602-0.82c-0.117,0.145-0.125,0.145-0.246,0.293c-0.086-0.516-0.086-0.496,0.09-0.934 c-0.125,0.078-0.23,0.156-0.355,0.254C19.121,19.301,19.73,18.43,20.609,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Eswatini);
export default __webpack_public_path__ + "static/media/icons8-eswatini.a82388f490d722b703857c95e0381ab6.svg";
export { ForwardRef as ReactComponent };